import { cn } from "@/lib/utils";

interface SectionHeadingProps {
	index?: string; // "01"
	title: React.ReactNode;
	kicker?: React.ReactNode;
	className?: string;
	as?: "h1" | "h2" | "h3";
	/** Se aplica al encabezado, para poder referenciarlo con aria-labelledby. */
	id?: string;
}

export function SectionHeading({
	index,
	title,
	kicker,
	className,
	as: Tag = "h2",
	id,
}: SectionHeadingProps) {
	return (
		<div className={cn("space-y-3", className)}>
			{kicker && (
				<div className="font-display text-sm text-terracotta">{kicker}</div>
			)}
			<Tag
				id={id}
				className="font-display font-semibold leading-[0.98] tracking-tight text-ink text-4xl sm:text-5xl"
			>
				{index && (
					<span className="text-terracotta mr-3 align-baseline text-2xl">
						{index}
					</span>
				)}
				{title}
			</Tag>
		</div>
	);
}
